<template>
  <div
    class="layout relative min-h-screen bg-gradient-to-b from-secondary to-secondary-300 flex justify-center items-start px-3"
  >
    <div
      ref="containerRef"
      class="layout__container w-full min-h-[400px] overflow-y-auto rounded-lg bg-cime-white py-4 px-4 sm:px-6 flex flex-col"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const containerRef = ref<HTMLElement | null>(null);
const route = useRoute();

watch(
  () => route.name,
  () => {
    containerRef.value?.scrollTo({ top: 0, behavior: 'instant' });
  }
);
</script>

<style scoped>
.layout {
  --container-pt: 12px;
  --container-pb: 12px;
  padding-top: var(--container-pt);
  padding-bottom: var(--container-pb);
}

.layout__container {
  height: calc(100vh - var(--container-pt) - var(--container-pb));
}
</style>
